import MediaCenter from 'hb-react/frontoffice/apps/MediaCenter/startup/MediaCenterApp';

const TopicMediaCenterContainer = ({ topic }) => (
  <MediaCenter
    topic={topic}
    configUrls={{
      media_center_path: () => Routes.topic_media_center_path(topic.id),
      media_center_folder_url: (folderUuid) =>
        !folderUuid || folderUuid === 'root'
          ? Routes.topic_media_center_path(topic.id)
          : Routes.topic_media_center_folder_view_path(topic.id, folderUuid),
      media_center_file_url: (fileUuid) =>
        Routes.topic_media_center_file_view_path(topic.id, fileUuid),
    }}
  />
);
export default TopicMediaCenterContainer;
